export const approvar_actionTypes = {
    APPROVE_PRODUCTS_AND_ROLES: "APPROVE_PRODUCTS_AND_ROLES",
    CONFIRM_TRAINING_COMPLETION: "CONFIRM_TRAINING_COMPLETION",
    REASSIGN_SUPERVISOR: "REASSIGN_SUPERVISOR",
    ALL_IN_ONE: "ALL_IN_ONE",
    APPROVE_EXCEPTION_HANDLER: 'APPROVE_EXCEPTION_HANDLER'
};